// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Life        = require("./life");
var React       = require("react");
var LogoSvg     = require("./logo.svg");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./app.css')));

function link(name, href) {
  return React.createElement("a", {
              href: href
            }, name);
}

var component = ReasonReact.statelessComponent("App");

function make(message, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "App"
                }, React.createElement("div", {
                      className: "App-header"
                    }, React.createElement("img", {
                          className: "App-logo",
                          alt: "logo",
                          src: LogoSvg
                        }), React.createElement("h2", undefined, message)), React.createElement("p", {
                      className: "App-intro"
                    }, "An implementation of ", link("Conway's Game of Life", "https://en.wikipedia.org/wiki/Conway%27s_Game_of_Life"), " written with ", link("ReasonML", "https://reasonml.github.io/"), " and ", link("React", "https://reactjs.org/")), ReasonReact.element(/* None */0, /* None */0, Life.make(/* array */[])));
    });
  return newrecord;
}

exports.link      = link;
exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/app.re
// module id = 38
// module chunks = 0